/** localStorage: install happened before login; report after auth. */
export const PWA_INSTALL_PENDING_STORAGE_KEY = 'pwa.install.pending';

/** localStorage: per-user “already reported to API” marker. */
export const PWA_INSTALL_REPORTED_STORAGE_KEY_PREFIX = 'pwa.install.reported.';
